/// <amd-module name="TFS/Admin/Groups/Pivots/Groups/Util/ArrayUtil" />
import { IIdentity } from "VSSUI/IdentityPicker";

export function mergeAndRemoveDuplicateMembers(a: IIdentity[], b: IIdentity[]) {
    return a.concat(
        b.filter(item => {
            return a.findIndex(i => i.subjectDescriptor === item.subjectDescriptor) < 0;
        })
    );
}
